import { render } from "./XIconSolidScrollText.vue?vue&type=template&id=3d7d0530"
import script from "./XIconSolidScrollText.vue?vue&type=script&lang=js"
export * from "./XIconSolidScrollText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidScrollText.vue"]])

export default __exports__